import React, { useCallback, useContext, useMemo } from 'react';
import AnalyticsContext from '../../../contexts/AnalyticsContext';
import { UIVersionContext } from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';
import V3Link from './V3Link';
import V2V1Link from './V2V1Link';
import useLinkedFromSource from './useLinkedFromSource';
import PopupContext from '../../../contexts/PopupContext';

const Link = ({
  entity,
  entityPrimaryFieldValue,
  app,
}: {
  entity: EntityDetails.Entity;
  entityPrimaryFieldValue: string;
  app: EntityDetails.App;
}) => {
  const { isOpen: isPopupBoardOrReport } = useContext(PopupContext);
  const { trackEvent } = useContext(AnalyticsContext);
  const { isV3 } = useContext(UIVersionContext);
  const source = useLinkedFromSource();
  const tooltip = useMemo(() => {
    return `${entity.name} Details`;
  }, [entity.name]);

  const trackOnClick = useCallback(() => {
    trackEvent('Entity Details - App Opened', {
      entityName: entity.name,
      entityPrimaryField: entity.primaryField,
      source,
    });
  }, [entity.name, entity.primaryField, source, trackEvent]);

  if (isV3 && !isPopupBoardOrReport) {
    return (
      <V3Link
        app={app}
        entity={entity}
        tooltip={tooltip}
        trackOnClick={trackOnClick}
        entityPrimaryFieldValue={entityPrimaryFieldValue}
      />
    );
  }

  return (
    <V2V1Link
      entity={entity}
      app={app}
      entityPrimaryFieldValue={entityPrimaryFieldValue}
      trackOnClick={trackOnClick}
      tooltip={tooltip}
    />
  );
};

export default Link;
